var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Badge',_vm._b({staticClass:"edited-badge",attrs:{"label":"Edited"}},'Badge',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }